import * as api from "./generated-api";
import { apiCall } from "./common";

export const getDefaultOrganization = (
  successCallback?: (currentOrganization: api.Organization) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Organization>(
    () => {
      return api.getDefaultOrganization();
    },
    successCallback,
    errorCallback
  );
};
